import {
  EXPECTED_KAREL_IMAGE_SIZE_PX,
  getCornerSize,
  getCornerX,
  getCornerY,
  getKarelImg,
  KAREL_IMG_PCT,
  type KarelEnvironment,
  type KarelType,
} from '../util';

interface AgentProps {
  state: KarelEnvironment;
  karelType: KarelType;
}

export const Agent = ({state, karelType = 'classic'}: AgentProps) => {
  const row = state.worldState.karelRow;
  const col = state.worldState.karelCol;
  const cornerSize = getCornerSize(state);
  const size = KAREL_IMG_PCT * getCornerSize(state);
  const offset = (cornerSize - size) / 2;
  const x = getCornerX(state, row, col) + offset;
  const y = getCornerY(state, row, col) + offset;
  const scale = size / EXPECTED_KAREL_IMAGE_SIZE_PX; // Calculate scaling factor relative to 100x100px
  return (
    <img
      className="karel"
      style={{
        marginLeft: x,
        marginTop: y,
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
      }}
      width={EXPECTED_KAREL_IMAGE_SIZE_PX}
      height={EXPECTED_KAREL_IMAGE_SIZE_PX}
      src={getKarelImg(state, karelType)}
      alt="Karel"
    />
  );
};
